import React from "react";
import { Card, colors, spacing, typography } from "../../../design-system";
import { formatCurrency } from "../helpers";

interface NetPayHighlightProps {
  netPay: number | string | null | undefined;
  ytdNet: number | string | null | undefined;
  currency?: string;
}

export default function NetPayHighlight({
  netPay,
  ytdNet,
  currency,
}: NetPayHighlightProps) {
  return (
    <Card
      style={{
        background: colors.brandSoft,
        border: "1px solid " + colors.brandSoftStrong,
        marginBottom: spacing[5],
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: spacing[4],
          flexWrap: "wrap",
        }}
      >
        <div>
          <div
            style={{
              ...typography.tiny,
              color: colors.brandPrimary,
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              marginBottom: 6,
              fontWeight: 600,
            }}
          >
            Net pay this period
          </div>
          <div
            style={{
              fontSize: 36,
              fontWeight: 700,
              color: colors.brandPrimary,
              fontFeatureSettings: '"tnum" 1',
              letterSpacing: "-0.02em",
              lineHeight: 1,
            }}
          >
            {formatCurrency(netPay, currency)}
          </div>
        </div>
        {ytdNet !== null && ytdNet !== undefined && (
          <div style={{ textAlign: "right" }}>
            <div
              style={{
                ...typography.tiny,
                color: colors.textMuted,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                marginBottom: 6,
              }}
            >
              YTD net
            </div>
            <div
              style={{
                ...typography.bodyStrong,
                color: colors.textPrimary,
                fontFeatureSettings: '"tnum" 1',
                fontSize: 20,
              }}
            >
              {formatCurrency(ytdNet, currency)}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}